import logo from "./logo.svg";
import "./App.css";
import Base from "./Base";

function App() {
  return <Base />;
}

export default App;
